import { Address, GenericObject, copyFields } from '@synergy/models';

import { Contact } from '../../../../common/models/contact';
import { ConverterCustomerSupplier } from './converter-customer-supplier';

export class ConverterCustomer {
    public id!: number;
    public name!: string;
    public deliveryAddress!: Address;
    public customerSuppliers!: ConverterCustomerSupplier[];
    public customerContact?: Contact;
    /**
     * Whether the account is locked today. The document carries the partner as
     * it was when it was written, so this is looked up on the master record
     * when the dialog opens (GF 12.10.2026, #2230).
     */
    public isLocked?: boolean;

    public static fromPlainObject(object: GenericObject): ConverterCustomer {
        const position = new ConverterCustomer();

        copyFields(object, position);

        if (object['deliveryAddress']) {
            position.deliveryAddress = Address.fromPlainObject(object['deliveryAddress']);
        }

        if (object['customerSuppliers']) {
            position.customerSuppliers = object['customerSuppliers'].map(ConverterCustomerSupplier.fromPlainObject);
        }

        return position;
    }
}
